import React from 'react';

function CircleCheckIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="10" fill="#37C26F"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M15.0246 6.29512C15.2695 6.50945 15.2917 6.88283 15.0738 7.12464L8.94074 13.932C8.72173 14.1751 8.3457 14.1905 8.10749 13.9663L4.55847 10.6252C4.33714 10.4169 4.31595 10.0697 4.50585 9.83229C4.71538 9.57038 5.10558 9.53433 5.35495 9.75862L8.10851 12.2354C8.3478 12.4506 8.71622 12.4314 8.93181 12.1924L14.2072 6.34337C14.4206 6.10668 14.7847 6.08522 15.0246 6.29512Z" fill="white"/>
        </svg>



    );
}

export default CircleCheckIcon;
